// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_id-0";
export var optionCard = "_id-1";